// Function loadCollageImageGridItemBlock loads the CollageImageGridItemBlock class by dynamically importing the js on demand if needed

export function loadCollageImageGridItemBlock($parentEl, isList = false) {

	return import(/* webpackChunkName: "wg-collage-image-grid-item-block-chunk" */ '../widgets/collageImageGridItemBlock').then(wg => {

		const { CollageImageGridItemBlock } = wg;

		let $wg = $parentEl.querySelector('[data-wg="CollageImageGridItemBlock"]');

		if(!$wg) {
			// console.info('CollageImageGridItemBlock: no widget found');
			return null;
		}

		if (isList) {
			let $wgCol = $parentEl.querySelectorAll('[data-wg="CollageImageGridItemBlock"]');
			let instances = [];
			$wgCol.forEach(($wg, i) => {
				instances.push( new CollageImageGridItemBlock($wg) );
			});
			if (instances.length === $wgCol.length) return instances;

		} else {
			return new CollageImageGridItemBlock($wg);
		}


	}).catch(error => error+'An error occurred while loading the CollageImageGridItemBlock widget');

}
